import axios from 'axios'
import router from 'router'

let ajax = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? '/api' : '/api',
    timeout: 30000
})

ajax.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
            case 403:
                router.replace({
                    path: '/login',
                    query: { redirect: router.currentRoute.fullPath }
                })
            }
        }
        return Promise.reject(error)
    }
)

export default ajax



// WEBPACK FOOTER //
// ./src/assets/js/ajax.js